module.exports = new __parcel__URL__("bossfight_neon_gold_button.5473a894.png").toString();